import React from 'react';
import {
  getBezierPath,
  useStore,
  BaseEdge,
} from 'reactflow';

export const getSpecialPath = (
  { sourceX, sourceY, targetX, targetY },
  offset,
) => {
  const centerX = (sourceX + targetX) / 2;
  const centerY = (sourceY + targetY) / 2;

  return `M ${sourceX} ${sourceY} Q ${centerX} ${
    centerY + offset
  } ${targetX} ${targetY}`;
};

const BiDirectionalEdge = ({
    source,
    target,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    markerEnd,
  }) => {
    console.log('BID:' ,sourcePosition);
    const isBiDirectionEdge = useStore((s) => {
      const edgeExists = s.edges.some(
        (e) =>
          (e.source === target && e.target === source) ||
          (e.target === source && e.source === target),
      );
  
      return edgeExists;
    });
  
    const edgePathParams = {
      sourceX,
      sourceY,
      sourcePosition,
      targetX,
      targetY,
      targetPosition,
    };
  
    let path = '';
  
    if (isBiDirectionEdge) {
      console.log('BID done');
      path = getSpecialPath(edgePathParams, sourceX < targetX ? 25 : -25);
    } else {
      console.log('no BID done');
      [path] = getBezierPath(edgePathParams);
    }
  
    return <BaseEdge path={path} markerEnd={markerEnd} />;
  };
  
  export default BiDirectionalEdge;




